import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { ADMIN_GROUPS } from '../login/Login';
import { IAuthState } from '../../redux/AuthRedux';
import { useNavigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../layout/core';

import './Platforms.scss';
import axios from 'axios';
import { BASE_URL } from '../../../config/environmentConfig';
import { toaster, Col } from 'rsuite';
import toastMessage from '../../components/ToastMessage';
import { IPlatform, IPlatformActions, PlatformItem, PlatformProvider } from '../../components/platforms/PlatformItem';
import { toAbsoluteUrl } from '../../utils';
import { ActionName } from '../../interfaces/links';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const platformsBreadCrumbs: Array<PageLink> = [
	// {
	// 	title: 'MENU.PLATFORMS',
	// 	path: '/platforms',
	// 	isSeparator: false,
	// 	isActive: false
	// },
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];



export const platformsItems = (onConnectButtonClick: (provider: PlatformProvider) => void): IPlatform[] => [
	{
		provider: PlatformProvider.Stripe,
		description: 'Rescue transactions from your Stripe account with our dedicated app.',
		onConnectButtonClick: () => onConnectButtonClick(PlatformProvider.Stripe),
		onDisconnectClick: (): void => {
			const stripeDisconnectUrl =
				process.env.REACT_APP_ENVIRONMENT === 'development' ||
				process.env.REACT_APP_ENVIRONMENT === 'local' ||
				process.env.REACT_APP_ENVIRONMENT === 'staging' ||
				process.env.REACT_APP_ENVIRONMENT === 'sandbox' ?
				'https://dashboard.stripe.com/test/settings/apps' :
				'https://dashboard.stripe.com/settings/apps';

			window.open(stripeDisconnectUrl, '_blank');
		},
		logo: <img className="platform-item-icon" src={toAbsoluteUrl('/media/icons/stripe.svg')} alt="stripe" />,
		actions: [],
		buttons: [],
		connectOptions: {
			actionName: ActionName.RedirectToStripeConnect,
			title: 'This will allow you to connect a Stripe account to FlexFactor',
			description: 'This will allow you to connect a Stripe account to FlexFactor.',
			actionIcon: <FontAwesomeIcon icon={faUpload} className="upload-icon"/>
		},
		readUrl: 'https://www.flexfactor.io/support'
	}
];

const Platforms: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [url, setUrl] = useState('');
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const { merchantState } = useMerchants();
	const { chosenMerchant } = merchantState;

	const userData: any = useSelector<RootState>(({ auth }) => auth.userData, shallowEqual);

	console.log('process.env.REACT_APP_ENVIRONMENT', process.env.REACT_APP_ENVIRONMENT);

	const isMerchantAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.MERCHANT_ADMIN);

	useEffect(() => {

	}, [chosenMerchant]);

	const handleClick = (provider: PlatformProvider): void => {
		axios.get(`${BASE_URL.API_CLIENT}/ProvidersOAuth/oauth-link?provider=${provider}`)
			.then(res => {
				window.open(res.data, '_blank');
			})
			.catch(err => {
				toaster.push(toastMessage({
					text: 'Failed to open the link',
					type: 'error',
					closable: true
				}), { placement: 'topEnd', duration: 0 });
			});
	};

	if (!isMerchantAdmin) {
		navigate('/');
	}

	return (
		<>
			<PageTitle breadcrumbs={platformsBreadCrumbs}>{t('MENU.PLATFORMS')}</PageTitle>

			<div className="card mb-5 mb-xl-8 p-10">
				<div className="platforms">
					<div className="fs-4 fw-bolder mb-5">Integrate to Flex using one of these popular platforms.</div>

					{platformsItems(handleClick).map((item, index) => (
						<React.Fragment key={index}>
							<Col xs={12} md={12}>
							<PlatformItem
								provider={item.provider}
								description={item.description}
								onConnectButtonClick={item.onConnectButtonClick}
								onDisconnectClick={item.onDisconnectClick}
								logo={item.logo}
								actions={item.actions}
								buttons={item.buttons}
								connectOptions={item.connectOptions}
								readUrl={item.readUrl}
							/>
			</Col>
						</React.Fragment>
					))}

					{/*<div className="provider-logo-box platform-item" onConnectButtonClick={(): void => handleClick('Stripe')}>*/}
					{/*	<img*/}
					{/*	src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABkCAAAAABoG6vuAAAD0ElEQVRo3u3YP2jqQBgA8EPIIDi4ZHFyEERcHJyyhA4ODm6ZCg4uXRwEB5eC4ODiUKFQcHASSsHJzaWDgxQ6dBAcBBEpOBQySHFQCeF7+XNJLuaMT19j4XHf0CaXMz8vd/fdGQS/FIjBDGYwgxnMYAYzmMEMZjCDGRws/FYUiuNfgPtIj5erwzIyYx0YrEzGKqX4GcO9QOBpqyjEUJIGdzD8FAicM+4t0i7NMDwPBE4Z976hXqsY1yqBDK415wNDM87FG8FMp3fkB2sj+wcTyNd86UyQoQnnPbW2oB55RvOVp2ixWJ+C+7cJ7eFGUlJrqp2Nm1kTjhW1eIWu/q9YA2hk+ZQiF81YAFSNgy7ASz6KQskKYU9r2QhCUaH+6QPPBeREXoUYIqOPhzjaFfS/9qgeaXcxogASLoq8ugegHlz7KLyKkE4IFM4Fr6BkNt/wOVjg8neAuHGQzjqVZ+YtyZag2jE443IKMHWd84Bh3AAvTEbauGPeXTigwyN3rXvous5TZ8F6B0APH8fwo+RVKlw1r2banYbE6ym4k0rzuM/S6VTDDSNYUuDbstVdd9od8adbe1lEhysZAReIxWbTF43x0XLNYwfmeF71tjj1AfCJ5QTAANn5dm0e5qgwHrN1a00i4JwbFgar7UZ998BdvVINF39Z1Y3Vy2xyhApbtxX7RFKktThjno098CNZPMF5Hn3rpXXjMEyFn+0Hmagv/GAJb3w88INe/ImLPyCEx/JYi6JPi/dRYuhUtsfhvC+8DuNi1TvU6bC1IpgRX14Ib/Do+tj8NQzjBJkwtv/W4gkFDh9bJNRmjMwgF8FWHy8UL4yOL4vKS8F+2JfBb/bmEx+0n+3o+24EJnhCh2Qbzp0BN+3ujPvtyQh4PrSOkvYnGmTKPwkb8zhuf1fJs4tQqHAfid0VAXNrO3Oh9tdytDsJd5yMj1rO/reFV91HUabCej1OrDw0M04f2wuUtjRvT8Lx8v2Ns3rDBmcQlCnX70sC53rqBFw+GIFlvb+d06hyEiai5ORJIoZUWDio9UX0mD6v92fAUTPxpQ+K21T4oJI59F8vgsNTvL90b2qsLH8AD3JkxrSeypNdtLcWzhS4vtPIA4tOX1ZD5P7x7cg8nnVus7FIOJqUes7An1azfDjMZ8oq9O6MeDQvLMyzu6UNizk+HElI5NYKlg/5RFT7fFpqT3039HtZ3hyW7WR56/uzIG7tbPYy7dfytyzvgnkHQmauq758YfC14ebVYf78tyE/AisxXii1h7Mde5fJYAYzmMEMZjCDGcxgBjOYwf8H/Af/3/NtAshqVAAAAABJRU5ErkJggg=="*/}
					{/*	alt="Stripe" className="provider-selector-logo" />*/}
					{/*</div>*/}

					{/*<button*/}
					{/*	type="button"*/}
					{/*	className="btn btn-primary btn-sm fw-bolder letter-spacing"*/}
					{/*	onConnectButtonClick={(): void => handleClick('Stripe')}*/}
					{/*>*/}
					{/*	Stripe*/}
					{/*</button>*/}
				</div>
			</div>
		</>
	);
};

export default Platforms;
